/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="97.4" height="95.59" viewBox="0 0 97.4 95.59" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <path d="M88.74,78.5h6v-5h-6Zm6.15,20h3.22v3.42H86.21V98.45h3.22V85.52H86.21V82h8.68Z" transform="translate(-28.5 -30)" fill="#ffb81c" fillRule="evenodd"/><g>
          <path d="M117.74,63.42H66.57a8.18,8.18,0,0,0-8.15,8.15v32.5a8.11,8.11,0,0,0,8.14,7.9h35.57l13.14,13.24.09.09a1.26,1.26,0,0,0,2-1V112h.32a8.18,8.18,0,0,0,8.16-8.16V71.57A8.18,8.18,0,0,0,117.74,63.42Zm-51.17,2.5h51.17a5.68,5.68,0,0,1,5.66,5.65v32.24a5.68,5.68,0,0,1-5.66,5.66H116a1.26,1.26,0,0,0-1.12,1.25V121.3l-11.37-11.46a1.26,1.26,0,0,0-.89-.37H66.57a5.61,5.61,0,0,1-5.65-5.66V71.57A5.68,5.68,0,0,1,66.57,65.92Z" transform="translate(-28.5 -30)" fill="#0e497b"/>
          <path d="M85.52,30a7.92,7.92,0,0,1,7.89,7.64v27h-2.5V37.89a5.42,5.42,0,0,0-5.17-5.39H36.39A5.42,5.42,0,0,0,31,37.67V68.89a5.42,5.42,0,0,0,5.17,5.39H37.9a1.26,1.26,0,0,1,1.25,1.12V85.59L50,74.65a1.24,1.24,0,0,1,.74-.36h9.08v2.5H51.42L38.79,89.51a1.25,1.25,0,0,1-2.13-.76v-12h-.26a7.91,7.91,0,0,1-7.89-7.64V37.89A7.92,7.92,0,0,1,36.14,30H85.52Z" transform="translate(-28.5 -30)" fill="#0e497b"/>
          <path d="M48.93,49.75a3.65,3.65,0,0,1,0,7.29,3.58,3.58,0,0,1-3.65-3.65,3.63,3.63,0,0,1,3.65-3.64" transform="translate(-28.5 -30)" fill="#ffb81c" fillRule="evenodd"/>
          <path d="M57.31,53.39A3.65,3.65,0,1,0,61,49.75a3.63,3.63,0,0,0-3.64,3.64" transform="translate(-28.5 -30)" fill="#ffb81c" fillRule="evenodd"/>
          <path d="M69.34,53.39A3.65,3.65,0,1,0,73,49.75a3.63,3.63,0,0,0-3.64,3.64" transform="translate(-28.5 -30)" fill="#ffb81c" fillRule="evenodd"/>
        </g>
      </svg>

    );
  }
}

Icon.displayName = 'TwoInformationalWordBubblesIcon';

export default Icon;
